import React from 'react';
// Fix: Import Page type from correct location
import { Page } from '../types';

interface TrustPartnersProps {
  navigate?: (page: Page) => void;
}

const TrustPartners: React.FC<TrustPartnersProps> = ({ navigate }) => {
  return (
    <div className="container mx-auto px-4 md:px-6">
      <div className="bg-white p-12 md:p-16 rounded-[3.5rem] shadow-sm border border-gray-100 relative overflow-hidden">
        {/* Dekoratives Hintergrund-Icon */}
        <div className="absolute -top-10 -right-10 text-[180px] opacity-[0.03] select-none pointer-events-none rotate-12">
          🛡️
        </div>

        <div className="max-w-4xl">
          <div className="flex items-center space-x-2 text-primary mb-6 font-bold uppercase tracking-widest text-sm">
            <span className="w-8 h-1 bg-primary rounded-full"></span>
            <span>Wissenschaft & Qualität</span>
          </div>
          
          <h2 className="text-3xl md:text-5xl font-black text-secondary mb-8 leading-tight">
            Wissenschaftlich fundiert. <br />
            <span className="text-primary italic">Medizinisch geprüft.</span>
          </h2>
          
          <p className="text-gray-600 text-lg md:text-xl mb-10 leading-relaxed max-w-3xl">
            Wir glauben, dass Erste-Hilfe-Wissen keine Grauzone sein darf. Deshalb basieren alle unsere Inhalte auf den aktuellsten Leitlinien des <a href="https://www.erc.edu/" target="_blank" rel="noopener noreferrer" className="text-secondary font-bold underline hover:text-primary transition-colors">European Resuscitation Council (ERC)</a> und werden von medizinischem Fachpersonal auf Herz und Nieren geprüft.
          </p>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 mb-16">
            <button 
              // Changed from 'medical-transparency' to 'medizinische-transparenz' to match the Page type definition
              onClick={() => navigate?.('medizinische-transparenz')}
              className="group bg-secondary text-white px-8 py-4 rounded-2xl font-bold hover:bg-secondary/95 transition-all shadow-lg flex items-center gap-3 active:scale-95"
            >
              <span>Medizinische Transparenz lesen</span>
              <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </button>
            <p className="text-gray-400 text-sm italic max-w-[250px]">
              Erfahre mehr über unsere Quellen und den Review-Prozess.
            </p>
          </div>
        </div>
        
        <div className="pt-12 border-t border-gray-100">
           <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center md:text-left">
              <div className="flex flex-col md:flex-row items-center md:items-start gap-4">
                 <div className="text-4xl text-primary font-black">100%</div>
                 <div>
                    <p className="text-secondary font-bold text-lg leading-none mb-1">Werbefrei</p>
                    <p className="text-gray-400 text-xs">Keine Ablenkung im Notfall-Modus.</p>
                 </div>
              </div>
              <div className="flex flex-col md:flex-row items-center md:items-start gap-4">
                 <div className="text-4xl text-primary font-black">Sicher</div>
                 <div>
                    <p className="text-secondary font-bold text-lg leading-none mb-1">Datenhoheit</p>
                    <p className="text-gray-400 text-xs">Verschlüsselt nach deutschen Standards.</p>
                 </div>
              </div>
              <div className="flex flex-col md:flex-row items-center md:items-start gap-4">
                 <div className="text-4xl text-primary font-black uppercase">ERC2025</div>
                 <div>
                    <p className="text-secondary font-bold text-lg leading-none mb-1">ERC-Standard</p>
                    <p className="text-gray-400 text-xs">Aktuellste Reanimations-Leitlinien.</p>
                 </div>
              </div>
           </div>
        </div>
      </div>
    </div>
  );
};

export default TrustPartners;